import { useState } from "react";
import {
  PriceDiscountTax,
  TAX,
  normalPriceCount,
  normalPriceRound,
} from "../../env";
import PostReq from "../../utils/PostReq";
import ErrorAction from "../../components/Modal/ErrorAction";
function PreOrderItem(props) {
  const user = props.user;
  const data = props.data;
  const total = props.total && props.total[props.index];
  const [showDetail, setDetail] = useState(0);
  const [Alert, setAlert] = useState(false);
  const returnSale = async (itemID) => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/faktor/return-faktor",
      body: { userId: user && user._id, faktorItemId: itemID },
    });
    if (result.error) {
      return;
    } else {
      props.setCart(result);
    }
    console.log(itemID);
  };
  return (
    <div className="order-wrapper">
      <div
        className="border-title"
        onClick={() => (showDetail ? setDetail(0) : setDetail(1))}
      >
        <div className="bu-name">
          {data.userDetail ? (
            <div className="col" style={{ maxWidth: "100%" }}>
              <p>{data.userDetail ? data.userDetail.username : "-"}</p>

              <a
                className="orderNoCol"
                style={{ minWidth: "auto", borderWidth: "1px" }}
              >
                {data.totalWeight}gr
                <i
                  className="fa-solid fa-weight no-font"
                  aria-hidden="true"
                ></i>
              </a>
              <a
                h
                className="orderNoCol"
                style={{
                  minWidth: "auto",
                  display: "flex",
                  borderWidth: "1px",
                }}
              >
                {data.userDetail.cCode ? data.userDetail.cCode : "----------"}
                <i
                  className="fa-solid fa-tags no-font"
                  aria-hidden="true"
                  style={{ position: "static" }}
                ></i>
              </a>
            </div>
          ) : (
            <></>
          )}
          {data.userDetail ? (
            <div className="col">
              <small>{data.userDetail ? data.userDetail.Address : "-"}</small>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="newCol">
          <p>شماره سفارش:</p>
          <strong>{data.faktorNo}</strong>
          <p style={{ marginRight: "auto" }}>مبلغ کل: </p>
          <strong>{normalPriceCount(data.fullPrice)}</strong>
        </div>
        {/* <div className="newCol">
          <p>وزن کل: </p>
          <strong>{data.totalWeight}</strong>
        </div> */}
        <div className="newCol">
          <small>
            تاریخ: {new Date(data.progressDate).toLocaleDateString("fa")}
          </small>
          <small>
            ساعت: {new Date(data.progressDate).toLocaleTimeString("fa")}
          </small>
          <a className="orderNoCol" href={"/print/official/" + data.faktorNo}>
            چاپ سفارش
          </a>
        </div>
        <div className="newCol">
          {data.description ? <small>توضیحات: </small> : <></>}
          <small>{data.description}</small>
        </div>
        <i
          className={
            showDetail
              ? "fa-solid extend-btn fa-angle-up"
              : "fa-solid extend-btn fa-angle-down"
          }
        ></i>
      </div>
      {showDetail ? (
        <div className=" admin-table-sec display-on height-on">
          <table>
            <thead>
              <tr>
                <th data-cell="ردیف">
                  <p>ردیف</p>
                </th>
                <th data-cell="شرح کالا">
                  <p>شرح کالا</p>
                </th>

                <th data-cell="واحد اصلی">
                  <p>واحد اصلی</p>
                </th>
                <th data-cell="مبلغ واحد">
                  <p>مبلغ واحد</p>
                </th>
                <th data-cell="تخفیف">
                  <p>تخفیف</p>
                </th>
                <th data-cell="مالیات">
                  <p>مالیات</p>
                </th>
                <th data-cell="مبلغ کل">
                  <p>مبلغ کل</p>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.items &&
                data.items.map((item, i) => (
                  <>
                    <tr className="product-tr product-info" key={i}>
                      <td className="long-td">
                        <p className="name">{item.title}</p>
                      </td>
                      <td data-cell="کد کالا">
                        {item.purchase ? <p>خرید</p> : <p>{item.sku}</p>}
                      </td>
                      {item.count ? (
                        <td data-cell="تعداد">
                          <p>{item.count}</p>
                        </td>
                      ) : (
                        <></>
                      )}
                      <td data-cell="وزن">
                        <p>{item.weight + "g"}</p>
                      </td>
                      <td data-cell="عیار">
                        <p>{item.ayar}</p>
                      </td>
                      {item.lab ? (
                        <td data-cell="آزمایشگاه">
                          <p>{item.lab}</p>
                        </td>
                      ) : (
                        <></>
                      )}
                      {item.riang ? (
                        <td data-cell="ری انگ">
                          <p>{item.riang}</p>
                        </td>
                      ) : (
                        <></>
                      )}
                      {item.priceDetail.poolSang ? (
                        <td data-cell="مبلغ سنگ">
                          <p>{normalPriceCount(item.priceDetail.poolSang)}</p>
                        </td>
                      ) : (
                        <></>
                      )}
                      <td data-cell="مبلغ واحد">
                        <p>{normalPriceCount(item.unitPrice)}</p>
                      </td>
                      {item.purchase ? (
                        <></>
                      ) : (
                        <td data-cell="مبلغ به ازای هر گرم">
                          <p>
                            {normalPriceCount(
                              item.priceDetail && item.priceDetail.unitGold
                            )}
                          </p>
                        </td>
                      )}

                      <td
                        data-cell="مبلغ کل"
                        className={
                          (!item.count && item.purchase) ||
                          item.priceDetail.poolSang
                            ? "long-td"
                            : ""
                        }
                      >
                        <p>{normalPriceCount(item.fullPrice)}</p>
                      </td>
                    </tr>
                    {item.isReturn ? (
                      <tr
                        style={{
                          gridTemplateColumns: "1fr",
                          backgroundColor: "red",
                        }}
                      >
                        <td
                          style={{
                            display: "unset",
                            textAlign: "center",
                            color: "white",
                          }}
                        >
                          مرجوع شد
                        </td>
                      </tr>
                    ) : item.canReturn ? (
                      <tr style={{ gridTemplateColumns: "1fr" }}>
                        <td style={{ display: "unset", textAlign: "left" }}>
                          <button
                            className="return-btn"
                            onClick={() => setAlert(item._id)}
                          >
                            برگشت از فروش
                          </button>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <></>
      )}
      {Alert ? (
        <ErrorAction
          status={"DELETE"}
          title={"برگشت از فروش"}
          text={"آیتم انتخاب شده مرجوع خواهد شد. آیا مطمئن هستید؟"}
          linkText={""}
          style={{ direction: "rtl" }}
          buttonText="مرجوع"
          close={() => setAlert()}
          action={() => returnSale(Alert)}
          color="red"
        />
      ) : (
        <></>
      )}
    </div>
  );
}
export default PreOrderItem;
